<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>
<style src="./ratings.scss" lang="scss"></style>

<script>
  import { mapActions, mapState } from 'vuex'
  import SearchFilter from './SearchFilter'
  import AppPagination from '@/components/ui/AppPagination'

  export default {
    name: 'RatingsPage',
    components: {
      AppPagination,
      SearchFilter,
      NewsTeaserHorizontal: () => import('@/components/modules/NewsTeaserHorizontal'),
    },
    metaInfo() {
      return {
        title: this.$t('meta.ratings.title'),
      }
    },
    data() {
      return {
        page: 1,
      }
    },
    computed: {
      ...mapState('ratings', [
        'ratings',
        'pagination',
        'filterActive',
        'options',
      ]),
    },
    watch: {
      '$route.query'(value) {
        this.page = value.page ? value.page : 1

        if (this.filterActive) {
          this.filterRatings({ page: this.page })
        } else {
          this.getRatings(this.page)
        }
      },
    },
    created() {
      if (this.$route.query.page) {
        this.page = this.$route.query.page
        this.getRatings(this.$route.query.page)
      } else {
        this.getRatings(this.page)
      }
    },
    destroyed() {
      this.clearRatings()
    },
    methods: {
      ...mapActions('ratings', [
        'getRatings',
        'filterRatings',
        'setFilterActive',
        'clearRatings',
      ]),
      onFilter(page = 1) {
        this.setFilterActive()
        if (parseInt(this.$route.query.page) !== parseInt(page)) {
          this.$router.push({ query: { page } })
        } else if (
          this.pagination.last < this.pagination.self &&
          parseInt(this.$route.query.page) !== this.pagination.first
        ) {
          this.$router.push({ query: { page: this.pagination.first } })
        } else {
          this.filterRatings({ page })
        }
      },
      updateRatings(page = 1) {
        this.getRatings(page)
      },
    },
  }
</script>
